import * as cnames from 'classnames'
import * as React from 'react'

import ImagePreview from '../../../components/imagePreview'
import TrendingSash from '../../../components/trendingSash'
import ImagePlaceholder from '../../imagePlaceholder'
import { IItemCard } from '../interface'
import LockupPreviewActionPanel from '../lockupPreviewActionPanel'

import * as styles from './itemCardSquarePreview.module.css'

interface IProps extends IItemCard {
  opaqueOnHoverClass: string
}

const ItemCardSquarePreview = (props: IProps) => {
  const { item, onItemLinkClick, opaqueOnHoverClass, rank, viewType } = props

  const rootClass = cnames({ [styles.listView]: viewType === 'list' })

  /* tslint:disable */
  return (
    <section className={rootClass}>
      {item.trending && <TrendingSash lazy large />}
      <a href={`${item.url}?s_rank=${rank}`} onClick={onItemLinkClick}>
        <ImagePlaceholder ratio={1}>
          <ImagePreview item={item} />
        </ImagePlaceholder>
      </a>
      <section className={cnames(styles.hoverOverlay, opaqueOnHoverClass)}>
        <a
          href={`${item.url}?s_rank=${rank}`}
          onClick={onItemLinkClick}
          className={styles.hoverOverlayClickHandler}
          role="toolbar"
          title={item.name}
        />
        <section className={styles.hoverOverlayActions}>
          <LockupPreviewActionPanel {...props} />
        </section>
      </section>
    </section>
  )
  /* tslint:enable */
}

export default ItemCardSquarePreview
